import React from 'react';

type Props = {
  fillIndicator?: boolean;
  image: any;
};

export default function AssetAvatar({ fillIndicator = false, image }: Props) {
  return (
    <div className="relative h-[3.5rem] w-[3.5rem]">
      <div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-full border-2 border-primary-800 bg-[#FF7A001A]">
        <img src={image} className="h-10 w-10 rounded-full object-cover" />
      </div>
      <div
        className={`absolute bottom-0 right-0 h-4 w-4 rounded-full border-2 border-primary-800 ${
          fillIndicator ? 'bg-primary-900' : 'bg-white'
        }`}
      ></div>
    </div>
  );
}
